import { _ } from "../../../../../core/polyglot/polyglot.js";
import PaymentSpreadStrategy from "../PaymentSpreadStrategy/PaymentSpreadStrategy.js";
import WidgetsListWidget from "../../../../../core/widgets/WidgetsListWidget/WidgetsListWidget.js";

/**
 * Function to inject the balance rule model fields into the form.
 *
 * @param {object} options - Object parameters
 * @param {object} options.form - The form to inject the fields into
 * @param {object} options.ruleModel - The rule model to extract the fields from
 * @param {Array} options.vatRates - The vat rates to inject into the form
 */
export default function addBalanceRuleModelFieldsToForm({
	form,
	ruleModel,
	vatRates,
}) {
	let selected = ruleModel.getVatRate();

	const vatRatesItems = vatRates.map((vatRate) => {
		if (vatRate.isDefault()) selected ||= vatRate;

		return {
			label: makeVatRateLabel(vatRate),
			value: vatRate,
		};
	});

	form.newDropDownField({
		label: _("Vat rate"),
		items: vatRatesItems,
		name: "vatRate",
		accessor: () => ruleModel.getVatRate(),
		mutator: (rate) => ruleModel.setVatRate(rate),
		selected,
	});

	appendPaymentSpread({ form, ruleModel });
}

function appendPaymentSpread({ form, ruleModel }) {
	const paymentSpread = makePaymentFields({ ruleModel });

	form.addRenderable({
		label: _("Payment Spread"),
		content: paymentSpread,
		accessor: () => ruleModel.getPaymentSpread(),
		mutator: (spread) => ruleModel.setPaymentSpread(spread),
		getFormValue: () => ruleModel.getPaymentSpread(),
		setFormValue: (spread) => ruleModel.setPaymentSpread(spread),
		validator: () => {
			const alertCollector = paymentSpread.validate();
			alertCollector.assertEmpty();
		},
	});
}

function makePaymentFields({ ruleModel }) {
	return new WidgetsListWidget({
		strategy: new PaymentSpreadStrategy({ ruleModel }),
	});
}

function makeVatRateLabel(vatRate) {
	const vatRateLabel = vatRate.getLabel();
	if (!vatRateLabel) {
		return vatRate.getValue().toString();
	}

	return vatRateLabel;
}
